import { PrescriptionRenewalResponse } from "../Api/Dto/PrescriptionRenewalResponse";
import { PrescriptionRenewal } from "./PrescriptionRenewal";

class PrescriptionRenewalModel {
    public prescriptionRenewals: PrescriptionRenewal[];
    public prescriptionRenewalsCount: number;
    public totalPageCount: number = 0;

    public static fromResponseModel(prescriptionRenewalResponse: PrescriptionRenewalResponse): Partial<PrescriptionRenewalModel> {
        if (!prescriptionRenewalResponse)
            return null;

        return {
            prescriptionRenewals: prescriptionRenewalResponse.PrescriptionRenewals?.map(PrescriptionRenewal.fromResponseModel),
            prescriptionRenewalsCount: prescriptionRenewalResponse.QueryRowCount
        };
    }
}

export { PrescriptionRenewalModel };
